import React from 'react'

//Components
import InfoGrid from 'components/infoGrid'
import AttachmentPreview from 'components/attachment'
import { Spin } from 'antd'

import styles from './index.module.scss'

function DemandsDetails({
	data,
	attachments,
	isLoadingAttachments,
	isErrorAttachments,
	handleDownloadAttachment,
	isDownloading,
	hasLegalAccess,
	generalInfoItems,
	legalInfoItems,
	resumeField,
}) {

	return (
		<div className={styles.detailsContainer}>
			<h3 className={styles.sectionTitle}>Informações Gerais</h3>
			<InfoGrid infoItems={generalInfoItems} />

			{resumeField?.value && (
				<section className={styles.resumeSection}>
					<h2 className={styles.resumeTitle}>Resumo da demanda</h2>
					<div className={styles.resumeBox}>
						<p>{resumeField.value}</p>
					</div>
				</section>
			)}

			{hasLegalAccess && (
				<section className={styles.sectionContainer}>
					<p className={styles.sectionTitle}>Campos exclusivos:</p>
					<InfoGrid infoItems={legalInfoItems} />
				</section>
			)}

			<section className={styles.descriptionSection}>
				<h2>Descrição da demanda</h2>
				<div className={styles.descriptionBox}>
					<p>{data.description ?? 'Nenhuma descrição fornecida.'}</p>
				</div>
			</section>

			<section className={styles.attachmentSection}>
				<h2>Anexos</h2>
				<div style={{ maxWidth: '400px', marginTop: '10px' }}></div>
				<ul className={styles.attachmentList}>
					{isLoadingAttachments && <Spin />}
					{!isErrorAttachments &&
						attachments?.map((attachment) => (
							<AttachmentPreview
								key={attachment.id}
								attachment={attachment}
								onDownload={() => handleDownloadAttachment(attachment)}
								loading={isDownloading}
							/>
						))}
					{(isErrorAttachments ||
						(!isLoadingAttachments && attachments?.length === 0)) && (
						<p>Nenhum anexo encontrado.</p>
					)}
				</ul>
			</section>
		</div>
	)
}

export default DemandsDetails
